import { render, staticRenderFns } from "./resumen-preguntas-ml.vue?vue&type=template&id=2cd23c0e&scoped=true&"
import script from "./resumen-preguntas-ml.vue?vue&type=script&lang=ts&"
export * from "./resumen-preguntas-ml.vue?vue&type=script&lang=ts&"
import style0 from "./resumen-preguntas-ml.vue?vue&type=style&index=0&id=2cd23c0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd23c0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
